import React from 'react';

import Paper from '@mui/material/Paper';

import FlexContainer from 'client/app/apps/disco-prototype/components/FlexContainer';
import { Liquidsets } from 'client/app/apps/disco-prototype/components/Liquidsets';
import { Steps } from 'client/app/apps/disco-prototype/components/Steps';
import { useDeviceConfigContext } from 'client/app/apps/disco-prototype/DeviceConfigProvider';
import { useStateContext } from 'client/app/apps/disco-prototype/StateProvider';

const Page = () => {
  const { deviceOptions } = useDeviceConfigContext();
  const { liquidSets, steps, handleAddStep, handleDeleteStep, handleUpdateStep } =
    useStateContext();

  return (
    <FlexContainer component={Paper}>
      <FlexContainer
        component={Paper}
        direction="column"
        sx={{ maxWidth: '300px', p: '16px' }}
      >
        <Liquidsets items={liquidSets} />
      </FlexContainer>
      <FlexContainer
        direction="column"
        p={8}
        scroll="auto"
        sx={{ background: '#f6f6f6' }}
      >
        <Steps
          steps={steps}
          targetOptions={liquidSets}
          deviceOptions={deviceOptions}
          handleAddStep={handleAddStep}
          handleDeleteStep={handleDeleteStep}
          handleUpdateStep={handleUpdateStep}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default Page;
